import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { useResponsive } from '../hooks/useResponsive';

export const Footer = () => {
  const { isMobile } = useResponsive();

  const { t } = useTranslation();

  const style = {
    container: {
      display: 'flex',
      width: '90%',
      paddingY: '0.5em',
    },
    labelCredit: {
      fontSize: isMobile ? '.7em' : '1em',
      color: '#8c8c8c',
    },
  };

  return (
    <Stack
      display='flex'
      direction='row'
      justifyContent='space-around'
      width='90%'
      alignItems='center'
    >
      <Stack sx={style.container} direction='column' spacing={0.5}>
        <Typography sx={style.labelCredit}>
          {t('footer.desc_created')}
        </Typography>
        <a
          href='https://www.someware.fr'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src='logo-someware.svg'
            style={{ width: isMobile ? 150 : 200, height: 40 }}
            alt='Logo someware'
          />
        </a>
      </Stack>
      <a
        href='https://www.maptiler.com'
        target='_blank'
        rel='noopener noreferrer'
      >
        <img
          src='maptiler-logo.svg'
          style={{ width: isMobile ? 150 : 200 }}
          alt='Logo maptiler'
        />
      </a>
    </Stack>
  );
};
